
export const FACEBOOK_APP_ID = "1404183577306768";

export const INSTAGRAM_APP_ID = "633996622886163";

export const LINKEDIN_APP_ID = "869g293ytmwt8s";
